import { IConfig } from '@cian/config/shared';
import { IGetOffersForPromoPageDesktopResponseSchema } from '../repositories/search-offers/entities/entities/GetOffersForPromoPageDesktopResponseSchema';
import { IPromoOffersState } from '../types/promoOffersSelection';

interface IPreparePromoOffersSelection {
  config: IConfig;
  promoOffersResponse: IGetOffersForPromoPageDesktopResponseSchema | null;
}

export const mapPromoOffersSelection = ({
  config,
  promoOffersResponse,
}: IPreparePromoOffersSelection): IPromoOffersState => {
  const isEnabled = Boolean(config.get<boolean>('Newbuilding.PromoOffersSelection.Enabled'));

  if (!promoOffersResponse || !promoOffersResponse.promoOffers) {
    return {
      isEnabled: false,
      listingUrl: '',
      offersIds: [],
      offers: [],
    };
  }

  const { listingUrl, offers } = promoOffersResponse.promoOffers;

  return {
    isEnabled,
    listingUrl,
    offersIds: offers.map(offer => offer.offerId),
    offers,
  };
};
